<ix-layout-grid class="h-100 d-flex flex-column">
  <ix-breadcrumb visibleItemCount="3">
    <ix-breadcrumb-item
      icon="project"
      [label]="'dpp.handover_documentation.passports' | translate"
      onkeypress=""
      (click)="navigateToPassports()"
    ></ix-breadcrumb-item>
    <ix-breadcrumb-item
      [label]="passportName || passportId"
      onkeypress=""
      (click)="navigateToViewPassport()"
    ></ix-breadcrumb-item>
    <ix-breadcrumb-item
      [label]="'dpp.handover_documentation.title' | translate"
    ></ix-breadcrumb-item>
  </ix-breadcrumb>
  <ix-content-header
    (backButtonClick)="navigateToViewPassport()"
    [hasBackButton]="true"
    [headerTitle]="'dpp.handover_documentation.title' | translate"
  >
  </ix-content-header>
  <ix-row class="m-3">
    <ix-pill [outline]="true" variant="neutral">
      {{ 'dpp.handover_documentation.total' | translate
      }}{{ handoverDocuments.length }}
    </ix-pill>
    <ix-pill [outline]="true" icon="checkbox" variant="neutral">
      {{ 'dpp.handover_documentation.selected' | translate
      }}{{ selectedDocuments.length }}
    </ix-pill>
  </ix-row>
  <ix-row class="m-3 gap-2">
    <ix-button icon="plus" onkeypress="" (click)="openAddDocumentModal()">{{
      'dpp.handover_documentation.add_document' | translate
    }}</ix-button>
    <ix-button
      icon="download"
      variant="secondary"
      onkeypress=""
      [disabled]="selectedDocuments.length === 0"
      (click)="downloadSelectedDocuments()"
      >{{ 'dpp.handover_documentation.download' | translate }}</ix-button
    >
    <ix-button
      icon="trashcan"
      variant="danger"
      onkeypress=""
      [disabled]="selectedDocuments.length === 0"
      (click)="deleteSelectedDocuments()"
      >{{ 'dpp.handover_documentation.remove' | translate }}</ix-button
    >
  </ix-row>

  @if (!loading) {
    <div class="m-3" [ngClass]="{'flex-grow-1': handoverDocuments.length > 0}">
      <ag-grid-angular
        id="listHandoverDocumentationTable"
        class="w-100"
        [ngClass]="{'h-100': handoverDocuments.length > 0}"
        [rowData]="handoverDocuments"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [gridOptions]="gridOptions"
        [suppressCellFocus]="true"
        (gridReady)="onGridReady($event)"
        (selectionChanged)="onSelectionChanged()"
      >
      </ag-grid-angular>
      @if (handoverDocuments.length === 0) {
        <div class="d-flex justify-content-center align-items-center">
          <ix-empty-state
            icon="add"
            [header]="
              'dpp.handover_documentation.no_documents_available' | translate
            "
            [subHeader]="
              'dpp.handover_documentation.add_first_document' | translate
            "
          >
          </ix-empty-state>
        </div>
      }
    </div>
  }
  @if (loading) {
    <ix-row class="m-3">
      <ix-col class="d-flex justify-content-center">
        <ix-spinner size="large"></ix-spinner>
      </ix-col>
    </ix-row>
  }
</ix-layout-grid>
